import { US_STATES } from '../../../domain/location/constants'

export const getCenterLocationState = (
  centerLocations: string[]
): string | undefined => {
  return Object.values(US_STATES)
    .find((stateName) => centerLocations.includes(stateName))
    ?.toLowerCase()
}
